import React, { useState } from "react";

const BenefitsOfRegistration = () => {
  const [activeTab, setActiveTab] = useState("individual");

  const renderContent = () => {
    if (activeTab === "individual") {
      return (
        <div className="text-black mt-9 space-y-6 text-[14px] sm:text-[18px] md:text-[36px] font-normal mx-auto px-4 md:px-0">
          <p>
            Registering as a farmer offers several key benefits that can significantly improve farm management and sustainability. Here are some reasons why registering is valuable:
          </p>
          <p className="md:mt-4">
            <strong>Access to Support Services:</strong> Registration allows farmers to receive support in managing their farms. This includes technical assistance, advice on best practices, and access to government programs aimed at boosting productivity and profitability.
          </p>
          <p>
            <strong>Resources and Grants:</strong> Registered farmers may be eligible for access to various resources such as seeds, equipment, and financial grants. These resources are often provided by government initiatives or development partners to help farmers grow and improve their businesses.
          </p>
          <p>
            <strong>Link to Verified Service Providers:</strong> Being a registered farmer gives you access to a network of verified service providers. This network can include suppliers, agronomists, veterinarians, and other experts who can provide quality services tailored to your specific needs.
          </p>
          <p>
            <strong>Partnerships with Development Organizations:</strong> Registration can connect farmers to development partners, NGOs, and international agencies that support agricultural development. These partnerships may open doors to collaborative projects, funding opportunities, and skill-building programs.
          </p>
          <p>
            <strong>Market Access:</strong> Farmers who are officially registered have better access to both local and international markets. Registration can provide opportunities to sell products to established buyers, cooperatives, or even government procurement programs, ensuring fair pricing and reliable sales channels.
          </p>
        </div>
      );
    } else {
      return (
        <div className="text-black mt-9 text-[14px] sm:text-[18px] md:text-[36px] font-normal mx-auto  px-4 md:px-0">
          <p className="font-bold">
            Registering as an organization on the FarmNet website offers several valuable benefits, especially for agricultural businesses, cooperatives, NGOs, input suppliers, and extension service providers.
          </p>
          <ul className="list-decimal list-inside marker:font-bold pl-5 space-y-3 mt-4">
            <li>
              <strong>Access to a Wider Network:</strong> Connect with farmers, buyers, agro-dealers, and other agricultural stakeholders. Build partnerships or customer bases through FarmNet’s platform.
            </li>
            <li>
              <strong>Visibility and Promotion:</strong> Create a profile showcasing your services, products, and impact. Promote your organization to a targeted audience involved in agriculture.
            </li>
            <li>
              <strong>Posting Services and Products:</strong> List farm inputs (seeds, fertilizers, tools), services (training, extension, logistics), and technologies. Reach potential customers directly through the platform.
            </li>
            <li>
              <strong>Data and Analytics:</strong> Get insights into market trends, user interests, and engagement statistics. Use this data to improve service delivery and targeting.
            </li>
            <li>
              <strong>Event and Training Announcements:</strong> Share details about training, workshops, or demo days with a relevant audience. Attract participants and collaborators through FarmNet’s community.
            </li>
            <li>
              <strong>Collaboration and Funding Opportunities:</strong> Find partners for joint projects or funding initiatives. Stay informed about grant opportunities or calls for proposals in agriculture.
            </li>
            <li>
              <strong>Enhanced Credibility:</strong> Being registered on a formal platform can boost your organization's reputation and trustworthiness. Especially useful for newer or smaller organizations seeking visibility.
            </li>
          </ul>
        </div>
      );
    }
  };

  return (
    <div className="bg-white">
      <div className="w-full px-4 md:px-24 py-10">
        <div className="flex items-center justify-between md:pr-40 mx-auto flex-col md:flex-row gap-4 md:gap-0">
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1748808650/FarmNet_Logo_Green_4_2_belxrn.png"
            alt="FarmNet Logo"
            className="w-[180px] md:w-[251px] h-auto"
          />
          <h1 className="text-[24px] sm:text-[32px] md:text-[54px] font-bold text-center flex-1">
            Why register as a Farmer
          </h1>
        </div>

        {/* Tab Labels */}
        <div className="flex justify-between md:mt-6 max-w-3xl mx-auto mt-4 px-1">
          <span
            className="text-[16px] sm:text-[24px] md:text-[36px] font-bold cursor-pointer"
            onClick={() => setActiveTab("individual")}
          >
            Individual
          </span>
          <span
            className="text-[16px] sm:text-[24px] md:text-[36px] font-bold cursor-pointer"
            onClick={() => setActiveTab("organization")}
          >
            Organization
          </span>
        </div>

        {/* Tab Switcher */}
        <div className="flex w-full mx-auto rounded-[10px] overflow-hidden h-[9px] mt-2">
          <button
            onClick={() => setActiveTab("individual")}
            className={`w-1/2 transition-all duration-300 ${
              activeTab === "individual" ? "bg-[#152C24]" : "bg-[#D9D9D9]"
            }`}
          ></button>
          <button
            onClick={() => setActiveTab("organization")}
            className={`w-1/2 transition-all duration-300 ${
              activeTab === "organization" ? "bg-[#152C24]" : "bg-[#D9D9D9]"
            }`}
          ></button>
        </div>

        {/* Description Content */}
        {renderContent()}
      </div>
    </div>
  );
};

export default BenefitsOfRegistration;
